import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Box, Container, Typography } from '@material-ui/core'
import { useStyles } from './SchoolShow_style'
import SimilarSchools from 'components/SimilarSchools/SimilarSchools'
import { Helmet } from 'react-helmet'

const NoSchoolShow = () => {
    const classes = useStyles()

    return (<>
        <Helmet>
            <meta name='robots' content='noindex' />
            <meta name='googlebot' content='noindex' />
        </Helmet>
        <Container className={classes.unavailable}>
            <Box className={classes.unavailable}>
                <Typography variant='h2' className={classes.unavailableTitle}>
                    <FormattedMessage id='item_show.does_not_exist.school' />
                </Typography>
            </Box>
        </Container>
        <SimilarSchools/>
    </>)
}

export default NoSchoolShow
